import { Post } from '../helpers';

type UserStatus = 'registered' | 'attended' | 'no_shows';

export default function DownloadUsers({
  channel,
  projectUuid,
  statuses,
  signal,
}: {
  channel: number;
  projectUuid: string;
  statuses: UserStatus[];
  signal?: AbortSignal;
}) {
  return Post<Response>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/download-users`,
    body: { statuses },
    signal,
  });
}
